import Loadable from 'react-loadable';

const LoyaltyWidgetLobby = Loadable({
  loader: () => import(/* webpackChunkName: "LoyaltyWidgetLobby" */ './LoyaltyWidgetLobby'),
  modules: ['./LoyaltyWidgetLobby'],
  loading: () => null
});

export default LoyaltyWidgetLobby;
